module.exports = __webpack_public_path__ + "static/media/orangeTick.105be889.png";